{
  "ancillaries": {
    "bundle": {
      "extraTitle": "Combos",
      "toggle": {
        "title": "Add Seat + Internet access",
        "description": {
          "WIAL": "Select your seat and combine it with a <b>Full flight Browse package</b> per passenger.",
          "WIEF": "Select your seat and combine it with a <b>Full flight Stream package</b> per passenger."
        },
        "notAvailableNotification": "This combo is not available for the selected seat"
      },
      "serviceIncludedInBundleNotification": "Comfort bundle package already selected for this passenger.",
      "selectionTitle": {
        "seatWifi": "{seatType} {seatNumber} + {includedProduct}"
      }
    },
    "toaster": {
      "errorSavingBundle": "We were unable to save your changes to the combos. Please try again."
    },
    "seat": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, seats <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, seats <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "meals": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, meals <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, meals <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "lounge": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, lounge <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, lounge <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "wifi": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, internet <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, internet <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "bags": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "cabinBaggage": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "pet": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, pets <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, pets <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "sport": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, sports equipment <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, sports equipment <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "priority": {
      "select": "Add",
      "selected": "Selected",
      "eligibility": {
        "notAvailableBus": "Unfortunately, priority services <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, priority services <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      },
      "noPriorityAvailable": "No priority services available for this part of your journey.",
      "maxedOut": "You have added the maximum number of priority services for this flight.",
      "inCart": "Added to the cart",
      "paid": "Confirmed",
      "alreadyPurchased": "Priority services has already been purchased for this passenger."
    },
    "selectPriority": "Buy priority services",
    "productList": {
      "subtitle": {
        "topPick": "Top pick for this flight:",
        "generic": "Choose from these options:",
        "added": "You've added:"
      }
    }
  },
  "services": {
    "seat": {
      "bundleNotification": "Combo <b>Seat + Internet access</b> is available",
      "bundleUnavailableSeatConfirmModal": {
        "title": "Add Seat + Internet access",
        "firstContentParagraph": "The seat type you have selected is not available for this combo.",
        "secondContentParagraph": "<b>To discover the available combo offers,</b> we will remove your current seat selection.",
        "closeButton": "Cancel",
        "continueButton": "View offers"
      }
    },
    "wifi": {
      "bundleRemovalConfirmModal": {
        "title": "Remove combo",
        "firstContentParagraph": "If you want to choose a different internet package or remove the <b>Seat + Internet access</b> combo you previously selected, <b>your seat selection will change to its original individual price.</b>",
        "secondContentParagraph": "Do you wish to continue?",
        "closeButton": "Cancel",
        "continueButton": "Yes, continue"
      }
    },
    "priority": {
      "title": "Priority services",
      "state": {
        "updating": {
          "ariaText": "Confirming priority services selection"
        },
        "purchased": {
          "default": "No priority services confirmed yet",
          "plural": "{numberOfItems} priority services confirmed",
          "singular": "1 priority service confirmed"
        },
        "selection": {
          "default": "No priority services selected yet",
          "plural": "{numberOfItems} priority services waiting in the cart",
          "singular": "1 priority service waiting in the cart"
        },
        "select": {
          "ariaText": "Purchase priority services",
          "text": "Purchase"
        },
        "modify": {
          "ariaText": "Modify priority services selection",
          "text": "Modify"
        }
      }
    }
  },
  "upsellCard": {
    "description": {
      "genericLongHaul": "Compare the meal service, seats and entertainment in different travel classes on long-haul flights."
    },
    "modalLink": {
      "allClasses": "Travel class differences"
    }
  },
  "purchase": {
    "payment": {
      "bundleCount": "Combos x {bundleCount}",
      "priorityCount": "Priority services x {amount}"
    }
  },
  "upsellPromotion": {
    "totalPriceInfo": "Total price for all passengers",
    "selected": "Selected",
    "changeToClassic": "Change to Classic",
    "continueWithLight": "Continue with Light",
    "continueWithSuperLight": "Continue with Superlight"
  },
  "phases": {
    "title": {
      "extrasB": "Final touches for your journey"
    },
    "sectionTitle": {
      "topPick": "Top pick for a trip like this",
      "allExtras": "All travel extras"
    }
  }
}
